<template>
    <main class="container">
        <div class="main-page">
            <div class="main-page__top">
                <div class="main-page__label fade-in" ref="label"></div>
                <div class="main-page__top--name fade-in" ref="name" :class="{'main-page__top--name-en' : $root.lang === 'en'}">
                    <div class="main-page__title">
                        <img :src="`/images/main-page/ms-trade-${$root.lang}-${sizeTitle}.svg`" alt="title">
                    </div>
                </div>
            </div>
            <main-slider :localizedText="localizedText"></main-slider>
            <div class="main-page__footer">
                <section class="main-page-card main-page__consultation">
                    <h2 class="main-page-card__title" v-html="localizedText.consultTitle"></h2>
                    <p class="main-page-card__text" v-html="localizedText.consultText"></p>
                    <z-button class="main-page-card__link" tag="a" :href="`/${$root.lang}/contacts`">
                        <z-icon name="modal-arrow"/>
                    </z-button>
                </section>
            </div>
        </div>
    </main>
</template>

<script>
import {mixinDevice} from '@/utils/mixin'
import MainSlider from './MainSlider.vue'
import {useLocalize} from './composable/useLocalize.js'

export default {
    name: 'main-page',
    mixins: [mixinDevice],
    components: {MainSlider},
    data () {
        return {
            localizedText: {}
        }
    },
    computed: {
        sizeTitle () {
            return this.isMobile() ? 'small' : 'big'
        }
    },
    methods: {
        setLocalizedText () {
            const {text} = useLocalize()
            this.localizedText = text
        },
        animateElements () {
            const label = this.$refs.label
            const name = this.$refs.name

            setTimeout(() => {
                label.classList.add('fade-in-appear')
            }, 100)

            setTimeout(() => {
                name.classList.add('fade-in-appear')
            }, 2000)
        }
    },
    mounted () {
        this.setLocalizedText()
        this.animateElements()
    }
}
</script>

<style lang="scss">
.main-page {
    display: flex;
    position: relative;

    &__top {
        position: absolute;
        top: 0;
        left: 0;
        margin-left: 157px;
        display: flex;
        flex-direction: column;
        max-width: 100%;

        &--name {
            z-index: 3;
            padding-left: 28px;
            padding-right: $token-spacers-s;
            padding-top: $token-spacers-xxxl;

            &-en {
                padding-left: 0 !important;
                position: relative;
                left: -4px;
            }
        }

        @include breakpoint(laptop) {
            max-width: 885px;

            &--name {
                padding-top: $token-spacers-xxl;
                padding-left: 18px;
            }
        }

        @include breakpoint(tablet) {
            margin-left: $token-spacers-m;
            max-width: 755px;

            &--name {
                padding-top: $token-spacers-xl;
                padding-left: 13px;
                padding-right: $token-spacers-xxs;

                &-en {
                    left: -5px;
                }
            }
        }

        @include breakpoint(v-tablet) {
            max-width: 460px;

            &--name {
                padding-left: 11px;
                padding-top: $token-spacers-m;

                &-en {
                    left: 0;
                }
            }
        }

        @include breakpoint(mobile) {
            margin-left: $token-spacers-xxs;
            max-width: 270px;

            &--name {
                padding-left: 6px;
                padding-top: $token-spacers-xs;

                &-en {
                    padding-left: $token-spacers-xxxs !important;
                }
            }
        }
    }

    &__label {
        display: flex;
        width: 411px;
        height: 405px;
        position: absolute;
        background: $token-colors-primary;
        background-blend-mode: color-burn;
        mix-blend-mode: multiply;
        top: 0;
        left: 0;
        z-index: 2;

        @include breakpoint(laptop) {
            width: 265px;
            height: 270px;
        }

        @include breakpoint(tablet) {
            width: 225px;
            height: 226px;
        }

        @include breakpoint(v-tablet) {
            width: 140px;
            height: 145px;
        }

        @include breakpoint(mobile) {
            width: 80px;
            height: 82px;
        }
    }

    &__footer {
        width: max-content;
        display: flex;
        justify-content: flex-end;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 5;

        @include breakpoint(mobile) {
            width: 100%;
        }
    }

    .main-page-card {
        max-width: 432px;

        @include breakpoint(laptop) {
            max-width: 345px;
        }

        @include breakpoint(tablet) {
            width: 50%;
            max-width: none;
            flex: 1;
        }

        @include breakpoint(v-tablet) {
            width: 100%;
        }
    }

    .fade-in {
        opacity: 0;
        transition: opacity 2.5s ease-in-out;
    }

    .fade-in-appear {
        opacity: 1;
    }
}

.main-page-card {
    background-color: $token-colors-white;
    padding: 40px 48px;
    padding-right: calc(64px + 48px);
    box-shadow: inset 0 0 0 1px #f1f1f1;
    position: relative;
    width: 100%;

    @include breakpoint(laptop) {
        padding: 32px;
        padding-right: calc(48px + 24px);
    }

    @include breakpoint(v-tablet) {
        padding-right: calc(48px + 32px);
    }

    @include breakpoint(mobile) {
        padding: 32px 24px;
        padding-right: calc(48px + 24px);
    }

    &__title {
        margin: 0 0 $token-spacers-xxs;
        color: $token-colors-black-90;
        font-size: 24px;
        font-weight: $token-typo-2-xl-desktop-weight;
        line-height: $token-typo-2-xl-desktop-lineheight;

        @include breakpoint(laptop) {
            font-size: 20px;
        }
    }

    &__text {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 0;

        @include breakpoint(laptop) {
            font-size: 14px;
        }
    }

    &__link {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 64px;
        height: 64px;
        min-width: auto !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        @include breakpoint(laptop) {
            width: 48px;
            height: 48px;
        }

        .z-icon {
            width: 40px;
            height: 40px;
            transform: rotate(90deg);

            @include breakpoint(tablet) {
                width: 32px;
                height: 32px;
            }
        }
    }
}
</style>
